"use client"

import { createContext } from "react"

export type NextRouter = {
  push: (
    path: string,
    options?: { scroll?: boolean; transitionTypes?: string[] }
  ) => void
  replace: (
    path: string,
    options?: { scroll?: boolean; transitionTypes?: string[] }
  ) => void
  back: () => void
  forward: () => void
  query: { [key: string]: string | string[] | undefined }
  pathname: string
}

export const EnvContext = createContext<{
  isKids: boolean
  isKidsPreview: boolean
  isPublic: boolean
  isSubmitted: number | undefined
  isReopened: number | null
  isExamine: number | undefined
  router: NextRouter
} | null>(null)

export const Provider = EnvContext.Provider
